/* eslint-disable react/prop-types */
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import i18n from "i18n";
import userStatusActions from "redux/actions/userStatusActions";

/**
 * Shown once per login/refresh when the connected user has vacationMode active,
 * asking whether to keep vacation mode on or turn it off.
 */
const VacationModeDialog = () => {
	const dispatch = useDispatch();
	const cockpitSettings = useSelector(state => state.userStatus?.auth?.user?.cockpitSettings);
	const [open, setOpen] = useState(false);
	const hasCheckedRef = useRef(false);

	useEffect(() => {
		if (!hasCheckedRef.current && cockpitSettings !== undefined) {
			hasCheckedRef.current = true;
			if (cockpitSettings?.vacationMode) {
				setOpen(true);
			}
		}
	}, [cockpitSettings]);

	const handleKeep = () => {
		setOpen(false);
	};

	const handleDisable = () => {
		dispatch(userStatusActions.saveOptionUser({ code: "vacationMode", action: "vacationMode", value: false }));
		setOpen(false);
	};

	return (
		<Dialog open={open} onClose={handleKeep} aria-labelledby="vacation-mode-dialog-title">
			<DialogTitle id="vacation-mode-dialog-title">
				{i18n.t("EDIT_FORM.vacationModeDialogTitle")}
			</DialogTitle>
			<DialogContent dividers>{i18n.t("EDIT_FORM.vacationModeDialogContent")}</DialogContent>
			<DialogActions>
				<Button onClick={handleDisable} color="primary">
					{i18n.t("EDIT_FORM.vacationModeDialogDisable")}
				</Button>
				<Button onClick={handleKeep} color="primary" variant="contained">
					{i18n.t("EDIT_FORM.vacationModeDialogKeep")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default VacationModeDialog;
